import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

// Helper function
const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

export const TaxReliefTypesColumns: ColumnDef<any>[] = [
	{
		accessorKey: "name",
		header: "Name",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 350,
		minSize: 250,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "code",
		header: "Code",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "country",
		header: "Country",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => {
			const country = getValue() as any;
			return country?.name || "--";
		},
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];
